import Preloader from 'components/Preloader';
import { useTranslation } from 'react-i18next';
import { BusinessDropDownButton } from './styles';
import { SupportLabel } from 'pages/Report/styles';
import {
  Typography,
  Box,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import WrapperList from 'components/BusinessList/WrapperList';
import { MainContainer } from 'components/BusinessListNew/styles';
import BrandListItems from 'redesign/BusinessDropDown/BrandListItems';
import useBrandList from 'redesign/BusinessDropDown/hooks/useBrandList';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LocationListItems from 'redesign/BusinessDropDown/LocationListItems';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { ChildContainer, SearchField } from 'components/BusinessListNew/styles';
import useBusinessDropDown from 'redesign/BusinessDropDown/hooks/useBusinessDropDown';

const BusinessDropDown = () => {
  const { t } = useTranslation();
  const {
    anchorEl,
    open,
    id,
    handleOpen,
    handleClose,
    checkPermission,
    all,
    isBrandLoading,
    currentBusiness,
    dropdownBusinessName,
    currentSelectedBrand,
    brandList,
    pagination,
    fetchMoreData,
    fetchMoreDataLoading,
    selectCurrentBrand,
    locationList,
    currentSelectedLocation,
    handleSubmit,
    showOnlyActiveBusinesses,
    handleShowOnlyActiveBusinesses,
    childContainerRef,
    isShowOnlyLoading,
  } = useBusinessDropDown();

  const {
    activeBrand,
    getItemStyles,
    handleBrandChange,
    searchValue,
    isSearch,
    displayBrandList,
    fetchMoreDataBySearch,
    paginationSearchBrand,
    searchLoading,
    retriggerSearch,
  } = useBrandList(
    currentSelectedBrand?._id,
    currentSelectedBrand,
    brandList,
    open,
    id
  );

  return (
    <>
      <BusinessDropDownButton
        id="businessNewListAll"
        aria-describedby={'businessNewListAll'}
        variant="outlined"
        disabled={
          isBrandLoading ||
          (!currentBusiness && Object.keys(currentBusiness).length === 0)
        }
        endIcon={open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        onClick={handleOpen}
      >
        <Typography noWrap fontSize={'14px'} color={'#333333'}>
          {isBrandLoading && <Preloader />}
          {currentBusiness &&
          Object.keys(currentBusiness).length > 0 &&
          !isBrandLoading
            ? dropdownBusinessName
            : t('All Businesses')}
        </Typography>
      </BusinessDropDownButton>
      <WrapperList
        id={id}
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
      >
        <MainContainer>
          {checkPermission(all['SUPER']) && (
            <Box sx={{ padding: '20px' }}>
              <SupportLabel>{t('header.search_for_support')} </SupportLabel>
              <SearchField
                multiline
                onChange={(e) => handleBrandChange(e)}
                placeholder={t('header.search_for_support_...')}
                value={searchValue}
                variant="outlined"
                size="small"
              />
            </Box>
          )}
        </MainContainer>
        <ChildContainer ref={childContainerRef}>
          <BrandListItems
            fetchMoreData={fetchMoreData}
            selectBrand={selectCurrentBrand}
            selectedBrand={currentSelectedBrand}
            selectedId={currentSelectedBrand?._id}
            hasMore={pagination?.hasNextPage}
            fetchMoreDataLoading={fetchMoreDataLoading}
            isSearch={isSearch}
            searchValue={searchValue}
            activeBrand={activeBrand}
            getItemStyles={getItemStyles}
            handleBrandChange={handleBrandChange}
            displayBrandList={displayBrandList}
            fetchMoreDataBySearch={fetchMoreDataBySearch}
            paginationSearchBrand={paginationSearchBrand}
            searchLoading={searchLoading}
            isShowOnlyLoading={isShowOnlyLoading}
          />
          <LocationListItems
            onKeyDown={() => {}}
            handleLocationChange={() => {}}
            locationChange={''}
            locationList={locationList}
            selectedLocations={() => {}}
            selectedLocation={currentSelectedLocation}
            selectedLocationId={currentSelectedLocation?._id}
            selectedBrand={currentSelectedBrand}
            isSearch={isSearch}
            searchValue={searchValue}
            searchLoading={searchLoading}
            isShowOnlyLoading={isShowOnlyLoading}
          />
        </ChildContainer>
        {checkPermission(all['SUPER']) && (
          <Box sx={{ padding: '0 20px' }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showOnlyActiveBusinesses}
                    onChange={() => {
                      handleShowOnlyActiveBusinesses(
                        searchValue,
                        isSearch,
                        retriggerSearch
                      );
                    }}
                  />
                }
                label="Show only active businesses"
              />
            </FormGroup>
          </Box>
        )}
        <Box>
          <Divider />
          <Box sx={{ p: 2, textAlign: 'right' }}>
            <Button
              id="businessList"
              color="primary"
              variant="contained"
              onClick={handleSubmit}
            >
              {t('orders_history.apply')}
            </Button>
          </Box>
        </Box>
      </WrapperList>
    </>
  );
};

export default BusinessDropDown;
